import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateTextService } from 'app/shared/services/translate-text.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-translate-field-value',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './translate-field-value.component.html',
  styleUrl: './translate-field-value.component.scss'
})
export class TranslateFieldValueComponent {
  @Input() value!: string;
  @Input() htmlContent: boolean = false;
  @Output() onTranslate = new EventEmitter<string>();

  translated: string = '';

  constructor(private translateTextService: TranslateTextService) { }

  seeTranslation() {
    const text: string = this.htmlContent ? this.extractTextFromHtml(this.value) : this.value;
    this.translateTextService.getTranslatedText(text).pipe(take(1)).subscribe((translatedText: string) => {
      this.translated = translatedText;
      this.onTranslate.emit(this.translated);
    });
  }

  seeOriginal() {
    this.translated = '';
    this.onTranslate.emit(this.translated);
  }

  extractTextFromHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
}
